import { useAtom } from "jotai";
import { useFormContext } from "react-hook-form";

import { useCrefazCltContext } from "@/app/hooks/useCrefazCltContext";
import { currentStep } from "@/app/store";
import { BasicInput } from "@/view/components/BasicInput";
import BasicOptions from "@/view/components/BasicOptions";
import { BasicSelect } from "@/view/components/BasicSelect";
import { Button } from "@/view/components/ui/button";

interface BankInfoFormProps {
  visible?: boolean;
}

export default function BankInfoForm({ visible }: BankInfoFormProps) {
  const [, setStep] = useAtom(currentStep);

  const {
    trigger,
    formState: { errors },
  } = useFormContext();

  const { items: banks } = useCrefazCltContext("banco");
  const { items: accountTypes } = useCrefazCltContext("tipoConta");

  const bankOptions = banks.map((bank) => ({
    label: `${bank.id} - ${bank.nome}`,
    value: String(bank.id),
  }));

  const accountTypeOptions = accountTypes.map((type) => ({
    label: type.nome,
    value: String(type.id),
  }));

  const bancarioErrors = (errors.bancario ?? {}) as Record<
    string,
    { message?: string }
  >;

  const handleNext = async () => {
    const isValid = await trigger("bancario");

    if (isValid) setStep((state) => state + 1);
  };

  return (
    <div className={visible ? "flex flex-col gap-8" : "hidden"}>
      <BasicOptions
        name="bancario.tipoConta"
        label="Tipo de conta"
        options={accountTypeOptions}
        error={bancarioErrors.tipoConta?.message}
      />

      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
        <BasicSelect
          name="bancario.bancoId"
          label="Banco"
          options={bankOptions}
          placeholder="Selecione seu banco"
          error={bancarioErrors.bancoId?.message}
        />

        <div className="grid grid-cols-2 gap-4">
          <BasicInput
            name="bancario.agencia"
            label="Agência com dígito"
            type="text"
            inputMode="numeric"
            maxLength={5}
            error={bancarioErrors.agencia?.message}
          />
          <BasicInput
            name="bancario.numero"
            label="Conta com dígito"
            type="text"
            inputMode="numeric"
            maxLength={12}
            error={bancarioErrors.numero?.message}
          />
        </div>
      </div>

      <div className="flex justify-end gap-5">
        <Button
          type="button"
          className="rounded-full bg-white02 px-8 py-3 font-semibold text-primary hover:bg-white02"
          onClick={() => setStep((state) => state - 1)}
        >
          Voltar
        </Button>
        <Button
          type="button"
          className="rounded-full px-8 py-3 font-semibold text-white"
          onClick={handleNext}
        >
          Continuar
        </Button>
      </div>
    </div>
  );
}
